export default __webpack_public_path__ + "static/media/коробка для бутылки.0fb1da93.jpg";